/**
 * Product Badge Component
 * 
 * Displays badges like "Best Seller", "Sale", "Black Friday", etc.
 */

'use client';

import styled from '@emotion/styled';

export type BadgeVariant = 'best-seller' | 'sale' | 'black-friday' | 'new' | 'limited' | 'selling-fast';

const StyledBadge = styled.div<{ variant: BadgeVariant }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => `${theme.space.xs} ${theme.space.sm}`};
  border-radius: ${({ theme }) => theme.radius.small};
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.bold};
  letter-spacing: 0.05em;
  text-transform: uppercase;
  line-height: 1;
  
  ${({ variant, theme }) => {
    switch (variant) {
      case 'best-seller':
      case 'selling-fast':
        return `
          background-color: ${theme.colors.text.primary};
          color: ${theme.colors.background.primary};
        `;
      case 'sale':
      case 'black-friday':
        return `
          background-color: ${theme.colors.semantic.urgent.color};
          color: ${theme.colors.background.primary};
        `;
      case 'new':
        return `
          background-color: ${theme.colors.semantic.positive.color};
          color: ${theme.colors.background.primary};
        `;
      case 'limited':
        return `
          background-color: ${theme.colors.pallete?.primary?.color || theme.colors.primary};
          color: ${theme.colors.background.primary};
        `;
      default:
        return `
          background-color: ${theme.colors.background.secondary};
          color: ${theme.colors.text.primary};
        `;
    }
  }}
`;

export interface ProductBadgeProps {
  variant: BadgeVariant;
  text: string;
}

export function ProductBadge({ variant, text }: ProductBadgeProps) {
  return <StyledBadge variant={variant}>{text}</StyledBadge>;
}

